'use strict';

var $ = require('jquery');

function getIsUserLoggedIn(){
    var userLoggedInPromise = $.Deferred();
    $.get( process.env.contextRoot + '/rest/accessManagement/loginStatus')
        .done(function (data) {
                console.log("getIsUserLoggedIn : " + data);
                if(data.loggedIn===true){
                    userLoggedInPromise.resolve(true);
                }else{
                    userLoggedInPromise.resolve(false);
                }
        })
        .fail(function(jqXHR, textStatus, error) {
            console.log( "error: status = %s", jqXHR.status);
            console.log( "error: responseText = %s", jqXHR.responseText);
            console.log( "error: textStatus = %s", textStatus);
            console.log( "error: error = %s", error);
            userLoggedInPromise.resolve(false);
        });

    return userLoggedInPromise.promise();
}

module.exports.getIsUserLoggedIn = getIsUserLoggedIn;


//////////////////
// WEBPACK FOOTER
// ./src/shared/scripts/modules/loginStatusService.js
// module id = Ytzv
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16